import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-casino-acc',
  templateUrl: './rg-casino-acc.component.html',
  styleUrl: './rg-casino-acc.component.scss'
})
export class RgCasinoAccComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
}
